import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBscGlobalState } from '../../../common/utils';
import { LATEST_SCHEMA_KEY, LEGACY_ATLASSIAN_GDPR_COOKIE_KEY } from '../../../constants';
import { getConsentToken } from '../../cookie-controls/get-consent-token';
import { getConsentTokenForSchemaVersion } from '../../cookie-controls/get-consent-token-for-schema-version';
import { getCookie } from '../../cookie-controls/get-cookie';
import { unpackUserPreferencesCookie } from '../../cookie-controls/transformer';
export function getPreferences() {
  return _getPreferences.apply(this, arguments);
}
function _getPreferences() {
  _getPreferences = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var packedPrefs, packedLocalPrefs, consentToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!getBscGlobalState().localConsentMode) {
            _context.next = 7;
            break;
          }
          packedPrefs = getCookie(LEGACY_ATLASSIAN_GDPR_COOKIE_KEY);
          if (packedPrefs) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", undefined);
        case 4:
          return _context.abrupt("return", unpackUserPreferencesCookie(packedPrefs));
        case 7:
          packedLocalPrefs = getConsentTokenForSchemaVersion(LATEST_SCHEMA_KEY);
          if (packedLocalPrefs) {
            _context.next = 13;
            break;
          }
          _context.next = 11;
          return getConsentToken();
        case 11:
          consentToken = _context.sent;
          return _context.abrupt("return", consentToken ? unpackUserPreferencesCookie(consentToken) : undefined);
        case 13:
          return _context.abrupt("return", unpackUserPreferencesCookie(packedLocalPrefs));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPreferences.apply(this, arguments);
}